import ArtistList from "../components/ArtistList";

const ListArtistPage = () => {
  return (
    <ArtistList />
  );
};

export default ListArtistPage;
